// eslint-disable-next-line deprecate/import
import Link from 'next/link';

import { useNavLayout } from '@shared/common/components/NavLayout/NavLayoutContext';
import { nextProjectUrl } from '@shared/constants/urls';

export const GetTokensButtons = () => {
  const { onBanxaBuyToken } = useNavLayout();

  return (
    <div className="flex flex-col gap-3 w-full">
      <div className="text-caption-sm-a">
        Don’t have enough USDT or SQR to Join?
        <br />
        Swap now or buy with a card to secure your tickets!
      </div>
      <div className="flex gap-2 justify-center w-full">
        <button className="msq-btn msq-btn-md msq-btn-secondary w-[118px] max-sm-msq:w-full">
          <Link target="_blank" href={nextProjectUrl.swap('/')}>
            Swap Tokens
          </Link>
        </button>
        <button
          onClick={onBanxaBuyToken}
          className="msq-btn msq-btn-md msq-btn-secondary w-[118px] max-sm-msq:w-full"
        >
          Get with Card
        </button>
      </div>
    </div>
  );
};
